import { Skeleton } from "@/components/ui/skeleton";

export const Loading = () => {
  return (
    <>
      <div className="flex items-center justify-end gap-2">
        <Skeleton className="h-9 w-28" />
      </div>
      <Skeleton className="h-48 w-full" />
      <Skeleton className="h-52 w-full" />
      <Skeleton className="h-60 w-full" />
    </>
  );
};
